import Vue from 'vue'
import Router from 'vue-router'
// @ 绝对路径 检索到 .....src/
// 如果我们Router当做局部模块使用 一定要Vue.use(Router)
// 以后在组件中  可以通过this.$router  获取Router实例化对象
// 路由信息对象 this.$routes
import login from '@/page/login'
import index from '@/page/index'
import resourceManage from '@/page/resourceManage/index'
import subjects from '@/page/resourceManage/subjects'
import teachers from '@/page/resourceManage/teachers'
import devices from '@/page/resourceManage/devices'
import rooms from '@/page/resourceManage/rooms'
import stations from '@/page/resourceManage/stations'
import examArrange from '@/page/examManage/examArrange'
import students from '@/page/examManage/students'
import examResults from '@/page/examManage/examResults'
import notice from '@/page/examManage/notice'
import examIndex from '@/page/examManage/index'
import examMiss from '@/page/examManage/examMiss'
import addExam from '@/page/examManage/addExam'
import examSeting from '@/page/examManage/examSeting'
import addStudent from '@/page/examManage/addStudent'
import scoreResult from '@/page/examManage/scoreResult'
import statisticIndex from '@/page/statisticsManage/index'
import subjectScores from '@/page/statisticsManage/subjectScores'
import studentScores from '@/page/statisticsManage/studentScores'
import subjectAnalysis from '@/page/statisticsManage/subjectAnalysis'
import studentAnalysis from '@/page/statisticsManage/studentAnalysis'
import teacherAnalysis from '@/page/statisticsManage/teacherAnalysis'
import totalScores from '@/page/statisticsManage/totalScores'
import subjectScoreDetail from '@/page/statisticsManage/subjectScoreDetail'
import studentScoreDetail from '@/page/statisticsManage/studentScoreDetail'
import singleExam from '@/page/statisticsManage/singleExam'
import subjectLine from '@/page/statisticsManage/subjectLine'
import stationAnalysis from '@/page/statisticsManage/stationAnalysis'
import standardAnalysis from '@/page/statisticsManage/standardAnalysis'
import teacherClassDetail from '@/page/statisticsManage/teacherClassDetail'
import theoryIndex from '@/page/theoryManage/index'
import theoryList from '@/page/theoryManage/list'
import examPaper from '@/page/theoryManage/examPaper'
import theoryScore from '@/page/theoryManage/scoreList'
import theoryCheck from '@/page/theoryManage/list'
import theoryQuestions from '@/page/theoryManage/theoryQuestions'
import studentManage from '@/page/theoryManage/studentManage'
import autoQuestion from '@/page/theoryManage/autoQuestion'
import addQuestion from '@/page/theoryManage/addQuestion'
import theoryView from '@/page/theoryManage/theoryView'
import dashboard from '@/page/dashboard'

Vue.use(Router)

// 配置路由规则
export default new Router({
  linkActiveClass: 'is-active',
  mode: 'hash',
  routes: [{
    path: "/login",
    name: 'login',
    component: login,
    meta: {
      keepAlive: true,
    }
  },
    {
      path: '/',
      component: index,
      name: 'index',
      redirect: {
        name: 'examArrange'
      },
      meta: {
        title: '主入口'
      },
      children: [
        {
          path: "/dashboard",
          name: "Dashboard",
          component: dashboard,
          meta: {
            title: '首页',
            activeMenu: 'dashboard'
          }
        },
        {
          path: "/resourceIndex",
          name: "resourceIndex",
          redirect: '/examArrange',
          meta: {
            title: '资源管理'
          },
          component: resourceManage,
          children: [{
            path: "/subjects",
            name: "subjects",
            component: subjects,
            meta: {
              title: '考试内容'
            }
          },
            {
              path: "/teachers",
              name: "teachers",
              component: teachers,
              meta: {
                title: '人员管理',
                activeMenu: 'teachers'
              }
            },
            {
              path: "/devices",
              name: "devices",
              component: devices,
              meta: {
                title: '设备管理',
                activeMenu: 'devices'
              }
            },
            {
              path: "/rooms",
              name: "rooms",
              component: rooms,
              meta: {
                title: '场所管理',
                activeMenu: 'rooms'
              }
            },
            {
              path: "/stations",
              name: "stations",
              component: stations,
              meta: {
                title: '考站管理',
                activeMenu: 'stations'
              }
            },
          ]

        },
        {
          path: "/examIndex",
          name: "examIndex",
          redirect: '/examArrange',
          meta: {
            title: '考试管理'
          },
          component: examIndex,
          children: [{
            path: "/examArrange",
            name: "examArrange",
            component: examArrange,
            meta: {
              title: '考试安排'
            }
          },
            {
              path: "/students",
              name: "students",
              component: students,
              meta: {
                title: '考生查询',
                activeMenu: 'students'
              }
            },
            {
              path: "/addExam",
              name: "addExam",
              component: addExam,
              meta: {
                title: '新增考试',
              }
            },
            {
              path: "/examSeting",
              name: "examSeting",
              component: examSeting,
              meta: {
                title: '考试设置',
              }
            },
            {
              path: "/addStudent",
              name: "addStudent",
              component: addStudent,
              meta: {
                title: '新增考生',
              }
            },
            {
              path: "/examResults",
              name: "examResults",
              component: examResults,
              meta: {
                title: '成绩查询',
                activeMenu: 'examResults'
              }
            },
            {
              path: "/notice",
              name: "notice",
              component: notice,
              meta: {
                title: '资讯&通知',
                activeMenu: 'notice'
              }
            },
            {
              path: "/examMiss",
              name: "examMiss",
              component: examMiss,
              meta: {
                title: '缺考统计',
                activeMenu: 'examMiss'
              }
            },
            {
              path: "/scoreResult",
              name: "scoreResult",
              component: scoreResult,
              meta: {
                title: '考试详情',
                // activeMenu: 'examResults'
              }
            },
          ]

        },
        {
          path: "/statisticsManage",
          name: "statisticsManage",
          redirect: '/subjectScores',
          meta: {
            title: '统计分析'
          },
          component: statisticIndex,
          children: [{
            path: "/subjectScores",
            name: "subjectScores",
            component: subjectScores,
            meta: {
              title: '项目成绩统计'
            }
          }, {
            path: "/subjectScoreDetail",
            name: "subjectScoreDetail",
            component: subjectScoreDetail,
            meta: {
              title: '项目成绩统计详情',
              activeMenu: 'subjectScores'
            }
          },
            {
              path: "/studentScores",
              name: "studentScores",
              component: studentScores,
              meta: {
                title: '考生成绩统计',
                activeMenu: 'studentScores'
              }
            }, {
              path: "/studentScoreDetail",
              name: "studentScoreDetail",
              component: studentScoreDetail,
              meta: {
                title: '考生成绩统计详情',
                activeMenu: 'studentScores'
              }
            },
            {
              path: "/subjectAnalysis",
              name: "subjectAnalysis",
              component: subjectAnalysis,
              redirect: '/singleExam',
              meta: {
                title: '项目成绩分析',
                activeMenu: 'subjectAnalysis'
              },
              children: [
                {
                  path: "/singleExam",
                  name: "singleExam",
                  component: singleExam,
                  meta: {
                    title: '单次考试分析',
                    activeMenu: 'subjectAnalysis'
                  },
                },
                {
                  path: "/subjectLine",
                  name: "subjectLine",
                  component: subjectLine,
                  meta: {
                    title: '项目成绩趋势图',
                    activeMenu: 'subjectAnalysis'
                  },
                },
                {
                  path: "/stationAnalysis",
                  name: "stationAnalysis",
                  component: stationAnalysis,
                  meta: {
                    title: '考站成绩分析',
                    activeMenu: 'subjectAnalysis'
                  },
                },
                {
                  path: "/standardAnalysis",
                  name: "standardAnalysis",
                  component: standardAnalysis,
                  meta: {
                    title: '考核点分析',
                    activeMenu: 'subjectAnalysis'
                  },
                },
              ]
            },
            {
              path: "/studentAnalysis",
              name: "studentAnalysis",
              component: studentAnalysis,
              meta: {
                title: '学生成绩分析',
                activeMenu: 'studentAnalysis'
              }
            },
            {
              path: "/teacherAnalysis",
              name: "teacherAnalysis",
              component: teacherAnalysis,
              meta: {
                title: '教学成绩分析',
                activeMenu: 'teacherAnalysis'
              }
            },
            {
              path: "/teacherClassDetail",
              name: "teacherClassDetail",
              component: teacherClassDetail,
              meta: {
                title: '班级成绩分析',
                activeMenu: 'teacherAnalysis'
              }
            },
            {
              path: "/totalScores",
              name: "totalScores",
              component: totalScores,
              meta: {
                title: '考生总成绩分析',
                activeMenu: 'totalScores'
              }
            },
          ]

        },
        {
          path: "/theoryManage",
          name: "theoryManage",
          redirect: '/theoryList',
          meta: {
            title: '理论考试管理'
          },
          component: theoryIndex,
          children: [{
            path: "/theoryList",
            name: "theoryList",
            component: theoryList,
            meta: {
              title: '考试管理',
              activeMenu: 'theoryList'
            }
          },
            {
              path: "/studentManage",
              name: "studentManage",
              component: studentManage,
              meta: {
                title: '学生管理',
                activeMenu: 'theoryList'
              }
            },
            {
              path: "/examPaper",
              name: "examPaper",
              component: examPaper,
              meta: {
                title: '试卷管理',
                activeMenu: 'examPaper'
              }
            },
            {
              path: "/addQuestion",
              name: "addQuestion",
              component: addQuestion,
              meta: {
                title: '新增试卷',
                activeMenu: 'examPaper'
              }
            },
            {
              path: "/autoQuestion",
              name: "autoQuestion",
              component: autoQuestion,
              meta: {
                title: '题库组卷',
                activeMenu: 'examPaper'
              }
            },
            {
              path: "/theory_score",
              name: "theoryScore",
              component: theoryScore,
              meta: {
                title: '成绩管理',
                activeMenu: 'theoryScore'
              }
            },
            {
              path: "/theory_view",
              name: "theoryView",
              component: theoryView,
              meta: {
                title: '试卷预览',
                activeMenu: 'examPaper'
              }
            },
            {
              path: "/theory_check",
              name: "theoryCheck",
              component: theoryCheck,
              meta: {
                title: '在线批卷',
                activeMenu: 'theoryCheck'
              },
            },
            {
              path: "/theory_questions",
              name: "theoryQuestions",
              component: theoryQuestions,
              meta: {
                title: '题库管理',
                activeMenu: 'theoryQuestions'
              }
            },
          ]

        },
      ]

    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js